import { render } from "./FIleIoPdfComponent.vue?vue&type=template&id=67890a30"
import script from "./FIleIoPdfComponent.vue?vue&type=script&lang=js"
export * from "./FIleIoPdfComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__